var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-dialog-import" },
    [
      _c(
        "wl-button",
        _vm._b(
          {
            attrs: {
              ret: "open-btn",
              loading: _vm.loading,
              disabled: _vm.disabled,
            },
            on: {
              click: function () {
                return (_vm.visible = true)
              },
            },
          },
          "wl-button",
          _vm.$$deepMerge(_vm.btnOptions, _vm.$attrs),
          false,
          true
        )
      ),
      _c(
        "wl-dialog",
        _vm._b(
          {
            staticClass: "import-dialog",
            attrs: {
              ret: "import-dialog",
              width: _vm.width,
              title: _vm.title,
              open: _vm.visible,
              loading: _vm.loading,
            },
            on: {
              "update:width": function ($event) {
                _vm.width = $event
              },
              "update:title": function ($event) {
                _vm.title = $event
              },
              "update:open": function ($event) {
                _vm.visible = $event
              },
            },
          },
          "wl-dialog",
          _vm.$$deepMerge(_vm.dialogOptions, _vm.$attrs),
          false,
          true
        ),
        [
          _c(
            "wl-list",
            _vm._b(
              { staticStyle: { "min-height": "500px" } },
              "wl-list",
              _vm.getListOptions,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }